import * as React from 'react';
import { Button } from '@material-ui/core';
import classnames from 'classnames';

import { ConfirmationPageContainer } from '../confirmation-page';
import { currency, longDate } from 'src/util/formatters';
import { PageFooterContainer } from 'src/core/components/page-footer/page-footer';

import styles from './confirmation-page.less';

interface Props {
    container: ConfirmationPageContainer;
}

export const ConfirmationPage: React.SFC<Props> = ({
    container: { estimate, signDate, gotoEstimate, bundleHasUnsignedEstimates },
}) => (
    <div className="page">
        <div className="page-content">
            <div className={classnames('centered-content', styles.centeredContent)}>
                {/* <div className={styles.contentWrapper}> */}
                <img
                    src="/assets/images/confirmationIcon.png"
                    srcSet="/assets/images/confirmationIcon.png, /assets/images/confirmationIcon@2x.png 2x, /assets/images/confirmationIcon@3x.png 3x"
                />

                <h2>You're all set</h2>
                <div className={styles.text}>
                    You will receive an email confirmation shortly. We will be in touch with you to
                    schedule your service.
                </div>

                <hr />

                {estimate && (
                    <div className={styles.estimateDetails}>
                        <div className={styles.itemDetails}>
                            <div className={styles.bold}>{estimate.name}</div>
                            <div>Accepted Estimate</div>
                        </div>
                        <div className={styles.itemDetails}>
                            <div>{currency(estimate.total || 0)}</div>
                            <div>Total</div>
                        </div>
                        <div className={styles.itemDetails}>
                            <div>{longDate(signDate)}</div>
                            <div>Date Signed</div>
                        </div>
                    </div>
                )}

                {bundleHasUnsignedEstimates && (
                    <div
                        className={classnames(
                            'non-sticky-button-wrapper',
                            styles.nonStickyButtonWrapper
                        )}
                    >
                        <Button
                            className="next-step-button"
                            variant="contained"
                            color="primary"
                            onClick={gotoEstimate}
                        >
                            View Other Estimates
                        </Button>
                    </div>
                )}
                {/* </div> */}
            </div>
        </div>
        <div className="space-filler"></div>
        <PageFooterContainer />
    </div>
);
